import Api from './Api'

export default class MediaKpiModule {
  public queryAutomatedFilters(module: any) {
    let automated_filters: any = {}
    let query: any = []

    if (module.query && module.query.length) {
      query = [...module.query]
    }

    if (module.local_filters) {
      Object.entries(module.local_filters).forEach(([key, value]) => {
        if (key === 'dynamic_filter') {
          automated_filters.start = module.local_filters.dynamic_filter.start
          automated_filters.end = module.local_filters.dynamic_filter.end
          automated_filters.shortcut = module.local_filters.dynamic_filter.shortcut
        } else {
          automated_filters[key] = value
        }
      })
    }
    let metrics: any = []
    let dimensions: any = []

    if (module.local_query && module.local_query.length) {
      query = module.local_query
    }
    if (module.metrics) {
      metrics = module.metrics
    }
    if (module.dimensions) {
      dimensions = module.dimensions
    }

    if (module.region) {
      query.push(`region:${module.region}`)
    }

    if (module.sales_rep) {
      query.push(`sr:${module.sales_rep}`)
    }

    if (module.special_group) {
      query.push(`special_group:${module.special_group}`)
    }

    query = [...new Set(query)]

    return {
      query,
      metrics,
      dimensions,
      automated_filters,
    }
  }

  public pagination_settings(context: any) {
    return {
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...context.query],
      mode: 'exclusive',
    }
  }

  public async paginate(payload: any) {
    let api = new Api()
    return api
      .get('media_kpis/paginate', payload)
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async overview(payload: any) {
    let api = new Api()
    return api
      .get('media_kpis/overview', payload)
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }

  public async inventoryMG(payload: any) {
    let api = new Api()
    return api
      .get('media_kpis/inventory-mg', payload)
      .then((response: any) => response.data)
      .catch(err => ({ data: [] }))
  }
}
